var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`r-tip ${_vm.type}`]},[_c('r-icon',{attrs:{"name":_vm.icon,"size":24}}),_c('r-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }